import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core" ;
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_date_basic_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `<div data-bind="attr: {id: idChart}, style: {width: csswidth, height: cssheight}"></div>`;
    }

    public getTemplateName(): string{

        return "amCharts_v4_date_basic_template";
    }

    protected buildViewModel(): any{

        let _this = this;
        return  {
            idChart: ko.observable("chartDiv_" + _this.idElement),
            deviceView: ko.observable('desktop'),
            dateFields: ko.observableArray([]),
            dateAxes: ko.observableArray([]),
            dateFormat: ko.observable("daily"),
            csswidth: ko.observable("98%"),
            cssheight: ko.observable("200px"),
            clickableLegend: ko.observable(1),
            cursorEnabled: ko.observable(1),
            nbOfXAxes: ko.observable(1),
            xScrollbarEnabled: ko.observable(1),
            truncateLabels: ko.observable(0),
            autoRotateLabels: ko.observable(1),
            labelMaxWidth: ko.observable(80),
            noDataMessage: ko.observable("No data available"),
        };
    }

    protected getMainElementClasses(): Array<string>{

        return ["dateGraph"];
    }

    public setDeviceView(deviceView){

        this.getTemplateViewModel().deviceView(deviceView);
    }

    public setDateFields(dateFields){

        this.getTemplateViewModel().dateFields(dateFields);
    }

    public setCssHeight(cssheight){

        this.getTemplateViewModel().cssheight(cssheight);
    }

    public setClickableLegend(value){

        this.getTemplateViewModel().clickableLegend(value);
    }

    public setCursorEnabled(value){

        this.getTemplateViewModel().cursorEnabled(value);
    }

    public setNbOfXAxes(value){

        this.getTemplateViewModel().nbOfXAxes(value);
    }

    public setDateFormat(value){

        this.getTemplateViewModel().dateFormat(value);
    }

    public setInterval(value){

        this.getTemplateViewModel().interval(value);
    }

    public setXScrollbarEnabled(value){

        this.getTemplateViewModel().xScrollbarEnabled(value);
    }

    public setTruncateLabels(value){

        this.getTemplateViewModel().truncateLabels(value);
    }

    public setAutoRotateLabels(value){

        this.getTemplateViewModel().autoRotateLabels(value);
    }

    public setLabelMaxWidth(value){

        this.getTemplateViewModel().labelMaxWidth(value);
    }

    public setNoDataMessage(value){

        this.getTemplateViewModel().noDataMessage(value);
    }

    public getDateAxes() {

        return this.getTemplateViewModel().dateAxes();
    }

    public applyValueAxisFormatting(yAxis) {

        yAxis.renderer.line.strokeOpacity = 1;
        yAxis.renderer.line.strokeWidth = 2;
        yAxis.renderer.line.stroke = am4core.color('#1886ff');
        yAxis.renderer.labels.template.fill = am4core.color('#1886ff');
    }

    public setupChart(chartData){

        let _this = this;

        /* Chart code */
        am4core.options.autoDispose = true;
        //am4core.unuseAllThemes();
        am4core.useTheme(am4themes_animated);

        // Create chart instance
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);

        // Needed to have the date show up in the correct position
        chart.dateFormatter.utc = true;
            
        // Add data
        chart.data = chartData;

        let xAxes = [];
        for (let i = 0; i < this.getTemplateViewModel().nbOfXAxes(); i++) {

            // Create axes
            let xAxis = chart.xAxes.push(new am4charts.DateAxis());

            xAxis.dataFields.date = this.getTemplateViewModel().dateFields()[i];
            
            if(this.getTemplateViewModel().dateFormat() == "fiveMinutes") {
                
                xAxis.dateFormatter = new am4core.DateFormatter();

                xAxis.dateFormatter.dateFormat = "yyyy-MMMM-dd HH:mm";
                xAxis.dateFormats.setKey("day", "MMMM-dd");
                xAxis.periodChangeDateFormats.setKey("day", "MMMM-dd");
                xAxis.dateFormats.setKey("hour", "HH:mm");
                xAxis.periodChangeDateFormats.setKey("hour", "HH:mm");
                xAxis.dateFormats.setKey("minute", "HH:mm");
                xAxis.periodChangeDateFormats.setKey("minute", "HH:mm");

                xAxis.tooltipDateFormat = "MM-dd HH:mm";
                xAxis.dateFormatter.utc = true;

                xAxis.baseInterval = {
                    "timeUnit": "minute",
                    "count": 5
                };

                xAxis.gridIntervals.setAll([
                    { timeUnit: "minute", count: 240 },
                    { timeUnit: "hour", count: 4 }
                ]);

                xAxis.renderer.labels.template.location = 0;
                xAxis.renderer.grid.template.location = 0;

                //chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm:ss";
            }
            else if(this.getTemplateViewModel().dateFormat() == "hourly") {


                xAxis.dateFormatter = new am4core.DateFormatter();

                xAxis.dateFormatter.dateFormat = "yyyy-MMMM-dd HH:mm";
                xAxis.dateFormats.setKey("day", "HH:mm");
                xAxis.periodChangeDateFormats.setKey("day", "HH:mm");
                xAxis.dateFormats.setKey("hour", "HH:mm");
                xAxis.periodChangeDateFormats.setKey("hour", "HH:mm");
                xAxis.dateFormats.setKey("minute", "HH:mm");
                xAxis.periodChangeDateFormats.setKey("minute", "HH:mm");

                xAxis.tooltipDateFormat = "MM-dd HH:mm";
                xAxis.dateFormatter.utc = true;

                if(this.getTemplateViewModel().nbOfXAxes() > 1){
                    if(i == 1){
                        xAxis.tooltip!.label.adapter.add("text", function(text, target) {
                            return "Comparison: " + text;
                        });
                    }
                }
                
                xAxis.renderer.minGridDistance = 50;

                xAxis.renderer.labels.template.location = 0.5;
                xAxis.renderer.grid.template.location = 0.5;
                
                //chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm:ss";
            }
            else if(this.getTemplateViewModel().dateFormat() == "daily"){

                xAxis.dateFormatter.dateFormat = "yyyy-MMMM-dd";
                xAxis.dateFormats.setKey("day", "MMMM-dd");
                xAxis.periodChangeDateFormats.setKey("day", "MMMM-dd");

                xAxis.baseInterval = {
                    "timeUnit": "day",
                    "count": 1
                };

                xAxis.tooltipDateFormat = "MM-dd";
                xAxis.dateFormatter.utc = true;

                if(this.getTemplateViewModel().nbOfXAxes() > 1){
                    if(i == 1){
                        xAxis.tooltip!.label.adapter.add("text", function(text, target) {
                            return "Comparison: " + text;
                        });
                    }
                }
                
                xAxis.renderer.minGridDistance = 50;

                xAxis.renderer.labels.template.location = 0.5;
                xAxis.renderer.grid.template.location = 0.5;

            }
            else if(this.getTemplateViewModel().dateFormat() == "weekly"){

                xAxis.dateFormatter.firstDayOfWeek = 0;
                
                xAxis.dateFormatter.dateFormat = "yyyy-MMMM-dd";
                xAxis.dateFormats.setKey("week", "MMMM-dd");
                xAxis.periodChangeDateFormats.setKey("week", "MMMM-dd");

                xAxis.tooltipDateFormat = "MMMM-dd";
                xAxis.dateFormatter.utc = true;

                if(this.getTemplateViewModel().nbOfXAxes() > 1){
                    if(i == 1){
                        xAxis.tooltip!.label.adapter.add("text", function(text, target) {
                            return "Comparison: " + text;
                          });   
                    }
                }
                
                xAxis.renderer.minGridDistance = 50;

                xAxis.renderer.labels.template.location = 0.5;
                xAxis.renderer.grid.template.location = 0.5;

                chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";
            }
            else{

                xAxis.dateFormatter.dateFormat = "yyyy-MMMM-dd";
                xAxis.dateFormats.setKey("month", "MMMM-dd");
                xAxis.periodChangeDateFormats.setKey("month", "MMMM-dd");

                xAxis.tooltipDateFormat = "MMMM-dd";
                xAxis.dateFormatter.utc = true;

                if(this.getTemplateViewModel().nbOfXAxes() > 1){

                    if(i == 1){
                        xAxis.tooltip!.label.adapter.add("text", function(text, target) {
                            return "Comparison: " + text;
                          });
                    }
                }
                
                xAxis.renderer.minGridDistance = 50;

                xAxis.renderer.labels.template.location = 0.5;
                xAxis.renderer.grid.template.location = 0.5;

                chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";
            }

            //xAxis.dateFormatter.timezoneOffset = 0;

            var label = xAxis.renderer.labels.template;

            if (this.getTemplateViewModel().labelMaxWidth() != null){

                //Set xaxis label max width
                label.maxWidth = this.getTemplateViewModel().labelMaxWidth();
            }

            if (this.getTemplateViewModel().truncateLabels() == 1) {

                //Truncagte xaxis label if label is longer than max width
                label.truncate = true;
            }

            if (this.getTemplateViewModel().autoRotateLabels() == 1){

                //Auto rotate x-axis values columns become too narrow
                xAxis.events.on("sizechanged", function (ev){

                    var axis = ev.target;
                    var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);

                    if (cellWidth < axis.renderer.labels.template.maxWidth){
                        axis.renderer.labels.template.rotation = -45;
                        axis.renderer.labels.template.horizontalCenter = "right";
                        axis.renderer.labels.template.verticalCenter = "middle";
                    } else {
                        axis.renderer.labels.template.rotation = 0;
                        axis.renderer.labels.template.horizontalCenter = "middle";
                        axis.renderer.labels.template.verticalCenter = "top";
                    }
                });
            }

            xAxes.push(xAxis);
        }

        // Add legend
        chart.legend = new am4charts.Legend();

        if (this.getTemplateViewModel().clickableLegend() == 0){

            //Disable clicking on Legend
            chart.legend.itemContainers.template.clickable = false;
            chart.legend.itemContainers.template.focusable = false;
            chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
        }

        if (this.getTemplateViewModel().xScrollbarEnabled() == 1){

            //Enable XYChartScrollbar
            chart.scrollbarX = new am4charts.XYChartScrollbar();
        }

        if (chartData && chartData.length === 0 ){

            // Give no data message if data is empty
            let message = chart.createChild(am4core.Label);
            message.text = this.getTemplateViewModel().noDataMessage();
            message.fontSize = 15;
            message.align = "center";
            message.isMeasured = false;

            message.x = am4core.percent(50);
            message.y = am4core.percent(50);
            message.verticalCenter = "middle";
            message.horizontalCenter = "middle";
        }

        if (this.getTemplateViewModel().cursorEnabled() == 1) {

            // Add cursor
            chart.cursor = new am4charts.XYCursor();
        }

        this.getTemplateViewModel().dateAxes(xAxes);

        return chart;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_date_basic_template.ts